import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';
import { CancelToken } from 'axios';
import { PlatformLinkingProvider } from '@okletsplay/core';

export const connectEvIoUserAccount = (data: { accountId: string }, cancelToken: CancelToken) => {
  return apiRequestCall({
    params: {
      method: 'POST',
      resource: ApiResource.UserConnections,
      urlPrefix: `${PlatformLinkingProvider.EvIo}`,
      params: { auth_code: data.accountId },
      cancelToken,
    },
    rejectOnCancel: false,
    successRequestMessage: 'Ev.io account connected',
  });
};
